var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-shadow as-panel"},[_c('h2',[_vm._v("Account")]),_c('p',[_vm._v(" Please make any account changes using the latest version of the app available "),_c('a',{attrs:{"href":"https://app.syn.bike/account"}},[_vm._v("here")]),_vm._v(". Any changes will applied to both app versions. ")])])
}]

export { render, staticRenderFns }